<script>
	import {Table,Styles} from 'sveltestrap';
</script>
<h1>About Page</h1>
<p>
	เวปตัวอย่างเพื่อสอนการใช้งาน Svelte
</p>
<img src="img/ninja.png" alt="นินจา" width="500">
<Styles/>